import styled, { css } from 'styled-components';
import { zIndex } from 'styles';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import { DEEP_BORDER_BOX } from 'common';

const WIDTH = '1.25rem';
const HEIGHT = '1.25rem';
const EFFECT_SIZE = '2rem';
const BORDER_WIDTH = '0.125rem';

export default {
  Wrapper: styled.span`
    ${DEEP_BORDER_BOX}
    position: relative;
    display: inline-flex;
    align-self: flex-start;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    margin-right: ${Tokens.SPACING.SPACING_8};
    width: ${WIDTH};
    height: ${HEIGHT};
    max-width: ${WIDTH};
    max-height: ${HEIGHT};
    min-width: ${WIDTH};
    min-height: ${HEIGHT};
    ${props => props.$disabled ? css`
      cursor: auto
    ` : css`
      cursor: pointer
    `}
`,
  Input: styled.input`
    position: absolute;
    top: 0;
    left: 0;
    cursor: inherit;
    margin: 0;
    opacity: 0;
    padding: 0;
    z-index: ${zIndex.INPUT};
    width: ${WIDTH};
    height: ${HEIGHT};
    max-width: ${WIDTH};
    max-height: ${HEIGHT};
    min-width: ${WIDTH};
    min-height: ${HEIGHT};
  `,
  FocusBorder: styled.div`
    pointer-events: none;
    position: absolute;
    height: ${EFFECT_SIZE};
    min-height: ${EFFECT_SIZE};
    width: ${EFFECT_SIZE};
    min-width: ${EFFECT_SIZE};
    border-radius: 100%;
    zIndex: 0;
    background-color: transparent;
    border: ${BORDER_WIDTH} solid ${({ $theme }) => $theme.focus.border}
  `,
  HoveredStyle: styled.div`
    pointer-events: none;
    position: absolute;
    height: ${EFFECT_SIZE};
    min-height: ${EFFECT_SIZE};
    width: ${EFFECT_SIZE};
    min-width: ${EFFECT_SIZE};
    border-radius: 100%;
    zIndex: 0;
    background: ${({ $theme, checked }) => checked ? $theme.checked.hover.background : $theme.unchecked.hover.background}
  `,
  RadioButtonErrorMessage: styled.p`
    margin: 0;
    ${css`${Tokens.TYPOGRAPHY.CAPTION}`}
    color: ${(({ $theme }) => $theme.content)}
  `
};